<template>
  <div v-if="isSent" class="moderation" :class="moderationSectionClass">
    <div class="moderation__inner">
      <Icon name="corner-down-right" class="moderation__arrow" />

      <section class="moderation__actions">
        <div
          v-b-tooltip="warningLightTooltip"
          class="moderation__warning-light"
          :class="warningLightClass"
        ></div>

        <span class="divider"></span>

        <Btn
          :variant="data.mark === false ? `link-success` : `link-not-selected`"
          icon="thumbs-up"
          size="sm"
          class="moderation__hide-comment-btn"
          tooltip="Oznacz jako: zgodna"
          @click="setMark(false)"
        >
        </Btn>

        <Btn
          :variant="data.mark === true ? `link-danger` : `link-not-selected`"
          icon="thumbs-down"
          size="sm"
          class="moderation__add-comment-btn"
          tooltip="Oznacz jako: niezgodna"
          @click="setMark(true)"
        >
        </Btn>

        <span class="divider"></span>

        <span v-if="data.autoMarked" class="moderation__auto-marked">
          Ocena automatyczna
        </span>
      </section>

      <section
        v-if="data.mark && !moderationDisabled"
        class="moderation__add-comment"
      >
        <h4 class="moderation__label" :for="getElementId('add-comment')">
          Dodaj komentarz
        </h4>
        <BaseTextarea
          :id="getElementId('add-comment')"
          v-model="data.comment"
          @input="emit()"
        ></BaseTextarea>
        <template v-if="commentTemplates.length > 0">
          <Label :for="getElementId('default-comment')" class="mt-3">
            Szablony komentarzy
          </Label>
          <BaseSelect
            :id="getElementId('default-comment')"
            v-model="defaultComment"
            track-by="comment"
            label="title"
            :get-object="false"
            :options="commentTemplates"
            @input="setComment"
          />
        </template>
      </section>

      <hr v-if="hasPreviousComments" />

      <section v-if="hasPreviousComments" class="moderation__comments">
        <h4 class="moderation__label">
          <span v-if="moderationDisabled">Komentarze:</span>
          <span v-else>Poprzednie komentarze:</span>
        </h4>
        <div
          v-for="(comment, idx) in previousComments"
          :key="idx"
          class="comment"
        >
          <template v-if="comment.mark !== false">
            <p class="comment__meta">
              <span
                class="comment__warning-light"
                :class="commentWarningLightClass(comment.autoCompliance)"
              ></span>
              <span class="comment__icon"><Icon name="thumbs-down"/></span>
              <span class="comment__user"> {{ comment.user }} </span>
              <span class="comment__date">
                {{ comment.date | moment("YYYY-MM-DD") }}
              </span>
            </p>
            <p class="comment__message">
              {{ comment.comment }}
              <!-- <a
                v-if="!moderationDisabled"
                href="#"
                class="comment__reuse"
                @click.prevent="useComment(idx)"
              >
                (Ponownie użyj tego komentarza)
              </a> -->
            </p>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import BaseFormControl from "../Form/BaseFormControl";
import BaseTextarea from "../Controls/BaseTextarea";
import BaseSelect from "../Controls/BaseSelect";

import { mapState, mapGetters } from "vuex";

import ModelFactory from "@/model/ModelFactory";

import CommentTemplates from "@/i18n/lang/certification-comments-pl.js";

import get from "lodash/get";

const _ = { get };

export default {
  name: "BaseAdminCertificationComment",
  components: {
    BaseTextarea,
    BaseSelect
  },
  extends: BaseFormControl,

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      data: ModelFactory.create("CommentModel", { name: this.nameClean }),
      showComments: false,
      defaultComment: null
    };
  },

  computed: {
    ...mapState("User", ["user"]),
    ...mapGetters("Event", ["commentsByQuestion"]),
    ...mapGetters("User", ["isAdmin"]),
    ...mapState("Form", ["formDisabled"]),
    ...mapState("Event", ["moderationDisabled", "event"]),

    comments() {
      let comments = this.commentsByQuestion(this.nameClean);
      return comments;
    },

    currentComment() {
      let current = this.comments.filter(item => item.type === "current");
      return current.length > 0
        ? current[0]
        : ModelFactory.create("CommentModel", { name: this.nameClean });
    },

    previousComments() {
      let previous = [];
      if (
        !this.moderationDisabled ||
        !this.comments ||
        !this.comments[0] ||
        !this.comments[0].comment
      ) {
        previous = this.comments.filter(
          item => item.type !== "current" && item.comment !== ""
        );
      } else {
        previous = this.comments.filter(item => item.comment != "");
      }

      return previous.length > 0 ? previous : false;
    },

    hasPreviousComments() {
      let hasComments = this.previousComments ? true : false;
      this.$emit("has:comments", hasComments);
      return hasComments;
    },

    isSent() {
      return !(this.event.status === "draft" && this.event.parent === null);
    },

    isOpened() {
      return true; // this.hasPrevious || this.showComments || this.data.mark;
    },

    warningLightTooltip() {
      let tooltip = "";
      switch (parseInt(this.data.autoCompliance)) {
        case 1:
          tooltip = "Pomarańczowa lampka";
          break;
        case 2:
          tooltip = "Czerwona lampka";
          break;
        default:
          tooltip = "Zielona lampka";
          break;
      }
      return tooltip;
    },

    warningLightClass() {
      return {
        "moderation__warning-light--ok": this.data.autoCompliance == 0,
        "moderation__warning-light--warning": this.data.autoCompliance == 1,
        "moderation__warning-light--not-compliant":
          this.data.autoCompliance == 2
      };
    },

    moderationSectionClass() {
      return {
        "moderation--opened": this.isOpened,
        "moderation--not-compliant": this.data.mark === true,
        "moderation--compliant": this.data.mark === false
      };
    },

    commentTemplates() {
      let name = this.name.replace(/\$each\.[0-9]{1,3}\./, "");
      let comments = _.get(CommentTemplates, name);
      return comments ? comments : [];
    },

    nameClean() {
      return this.name.replace("$each.", "");
    }
  },
  watch: {
    currentComment: function(newValue) {
      this.data = ModelFactory.create("CommentModel", {
        ...newValue,
        name: this.nameClean
      });
      this.emit();
    },

    hasPreviousComments: function(newValue) {
      this.showComments = newValue;
    },

    comments: function(newValue) {
      if (!newValue.length && this.moderationDisabled) {
        this.$emit("set:moderation", false);
      }
    }
  },

  created() {
    // this.$store.dispatch("User/getCurrent");
  },

  methods: {
    commentWarningLightClass(autoCompliance) {
      return {
        "comment__warning-light--ok": autoCompliance == 0,
        "comment__warning-light--warning": autoCompliance == 1,
        "comment__warning-light--not-compliant": autoCompliance == 2
      };
    },
    getElementId(suffix) {
      return `comment-${this.nameClean}` + (suffix ? `-${suffix}` : "");
    },

    emit() {
      // this.$emit("edit:comment", this.data);
      this.$store.commit("Event/SET_COMMENT", this.data);
    },

    commentStatusClass(mark) {
      return {
        "comment__status--compliant": !mark,
        "comment__status--not-compliant": mark
      };
    },

    setComment(comment) {
      this.data.comment = comment;
      this.emit();
    },

    setMark(toggle) {
      if (this.data.autoCompliance < 2 && !this.moderationDisabled) {
        this.data.mark = toggle;
        this.emit();
      }
    },

    useComment(idx) {
      let message = this.comments[idx].comment;
      this.data.comment = message;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.moderation {
  // max-width: 40%; //58.33333%;
  padding-left: 30px;
  position: relative;

  &__inner {
    border-left: 4px solid transparent;
  }

  &__arrow {
    position: absolute;
    left: -4px;
    top: 4px;
    font-size: 1.8em;
    fill: $col-polmed-gray1;
  }

  &--opened &__inner {
    transition: background 0.3s, border 0.3s;
    background: lighten($col-polmed-gray, 8%);
    border-left: 4px solid transparent;
  }

  &--not-compliant &__inner {
    background: adjust-color(lighten($col-polmed-gray, 5%), $red: 10);
    border-left: 4px solid $col-polmed-red;
  }

  &--compliant &__inner {
    background: adjust-color(lighten($col-polmed-gray, 5%), $green: 5);
    border-left: 4px solid $col-polmed-green;
  }

  .btn-link-not-selected {
    svg {
      fill: lighten($col-polmed-gray1, 11%);
    }
  }

  hr {
    margin: 0;
  }

  &__auto-marked {
    font-size: 0.8em;
    color: $col-polmed-gray1;
  }

  .divider {
    border-left: 1px solid $col-polmed-gray1;
    width: 1px;
    height: 100%;
    margin: 0 5px;
  }

  &__label {
    font-size: 1em;
    margin: 10px 0;
  }

  &__add-comment {
    font-size: 0.8em;
    padding: 10px 15px;
  }

  &__comments {
    font-size: 0.8em;
    padding: 10px 15px 0;
  }

  &__add-comment {
    textarea {
      font-size: 1em;
    }
  }
}

.moderation__warning-light,
.comment__warning-light {
  background: white;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: inline-block;
  line-height: 20px;
  vertical-align: baseline;
  top: 3px;
  position: relative;
  margin: 0 10px 0 15px;

  &--ok {
    background: $col-polmed-green;
  }
  &--warning {
    background: $col-polmed-orange;
  }
  &--not-compliant {
    background: $col-polmed-red;
  }
}

.comment {
  border-bottom: 1px dotted $col-polmed-gray;
  margin-bottom: 10px;
  padding-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
  &__message {
    margin: 0;
  }
  &__warning-light {
    margin-left: 0;
    margin-right: 5px;
    width: 10px;
    height: 10px;
    top: 1px;
  }
  &__icon {
    position: relative;
    width: 1em;
    height: 1em;
    display: inline-block;
    svg {
      top: -3px;
      left: 0;
      position: absolute;
      fill: $col-polmed-red;
      vertical-align: middle;
    }
  }
  &__meta {
    float: left;
    margin: 0 10px 0 0;
    font-weight: bold;
    &:after {
      content: ": ";
    }
  }
  &__date {
    &:before {
      content: "(";
    }
    &:after {
      content: ")";
    }
  }
  &__reuse {
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover {
    .comment__reuse {
      opacity: 1;
    }
  }
}
</style>
